import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timeline-item"
// Handles collapsible timeline items with copy-context and show-more evidence
export default class extends Controller {
  static targets = ["body", "chevron", "evidenceShort", "evidenceFull", "evidenceToggleLabel"]

  connect() {
    // Start collapsed
    this._expanded = false
    this._evidenceExpanded = false
  }

  // Toggle the expanded body open/closed
  toggle(event) {
    // Don't toggle when clicking the copy button or evidence toggle
    if (event.target.closest('[data-action*="copyContext"]') ||
        event.target.closest('[data-action*="toggleEvidence"]')) {
      return
    }

    this._expanded = !this._expanded

    if (this.hasBodyTarget) {
      this.bodyTarget.classList.toggle("hidden", !this._expanded)
    }

    if (this.hasChevronTarget) {
      this.chevronTarget.style.transform = this._expanded ? "rotate(180deg)" : ""
    }
  }

  // Copy signal context to clipboard
  copyContext(event) {
    event.stopPropagation()
    const text = event.params.context
    if (!text) return

    navigator.clipboard.writeText(text).then(() => {
      const btn = event.currentTarget
      const original = btn.textContent
      btn.textContent = "\u2705"
      setTimeout(() => { btn.textContent = original }, 1500)
    }).catch(() => {
      // Fallback for older browsers
      const ta = document.createElement("textarea")
      ta.value = text
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      document.execCommand("copy")
      document.body.removeChild(ta)
    })
  }

  // Toggle short/full evidence within the expanded body
  toggleEvidence(event) {
    event.stopPropagation()
    this._evidenceExpanded = !this._evidenceExpanded

    if (this.hasEvidenceShortTarget) {
      this.evidenceShortTarget.classList.toggle("hidden", this._evidenceExpanded)
    }
    if (this.hasEvidenceFullTarget) {
      this.evidenceFullTarget.classList.toggle("hidden", !this._evidenceExpanded)
    }
    if (this.hasEvidenceToggleLabelTarget) {
      this.evidenceToggleLabelTarget.textContent = this._evidenceExpanded ? "Show less" : "Show more"
    }
  }
}
